import { useState } from "react";
import { Blurhash } from "react-blurhash";

import { urlFor } from "../../client";
import Button from "../Utils/Button";

const PlayerHash =
  "XCO;6|.7.T%19FD$yDwbsoyEX8Q,x]o~R.WBM{WVaxt8oMXAtRZ~RPt-Vsem";

export default function Program({ item }) {
  const { slug, mainImage, name, surname } = item;
  const [loaded, setLoaded] = useState(false);

  // console.log(loaded);
  // Function to handle image load event
  const handleImageLoad = () => {
    setLoaded(true);
  };

  return (
    <div className="Programs__First--div">
      {!loaded && (
        <div className="Programs__First--image">
          <Blurhash
            hash={`${PlayerHash}`}
            width="100%"
            height="100%"
            resolutionX={32}
            resolutionY={32}
            punch={1}
          />
        </div>
      )}
      <img
        alt={slug.current}
        src={
          mainImage
            ? urlFor(mainImage).url()
            : require("../../assets/images/players/Promise Meliga.jpg")
        }
        onLoad={handleImageLoad}
        className={`${loaded ? "block" : "hidden"} Programs__First--image`}
      />

      <div className="Programs__Text--div">
        {surname && <p className="Programs__text">{`${surname}`}</p>}{" "}
        {name && <p className="Programs__text">{`${name}`}</p>}
        {slug && (
          <div style={{ display: "flex" }}>
            <Button
              text={"read more"}
              div={{
                padding: "5px 20px",
                textTransform: "capitalize",
                backgroundColor: "#fff",
                width:"100%"
              }}
              link={{
                fontSize: "1.6rem",
                letterSpacing: "2px",
                color: "#007ebb",
                fontWeight: "700",
              }}
              url={`/players/${slug.current}`}
            />
          </div>
        )}
      </div>
    </div>
  );
}
